import { ballKey } from '../lib/balls';
import { useT, type MessageKey } from '../lib/i18n';
import type { Suggestion } from '../lib/useMatch';

interface Props {
  suggestions: Suggestion[];
  onResolve: (suggestion: Suggestion, accept: boolean) => void;
}

type Translate = (key: MessageKey, vars?: Record<string, string | number>) => string;

function describe(event: Suggestion['event'], t: Translate): string {
  switch (event.type) {
    case 'shot.pot':
      return event.count > 1
        ? t('match.suggestPotMany', { n: event.count, ball: t(ballKey(event.color)) })
        : t('match.suggestPot', { ball: t(ballKey(event.color)) });
    case 'shot.miss':
      return t('match.suggestMiss');
    case 'shot.foul':
      return t('match.suggestFoul', { n: event.points });
    default:
      return event.type;
  }
}

/** Pending AI suggestions in `assisted` mode. Nothing scores until confirmed. */
export function SuggestionQueue({ suggestions, onResolve }: Props) {
  const t = useT();

  if (suggestions.length === 0) return null;

  return (
    <div className="panel space-y-2 border border-ball-yellow/40">
      <div className="text-xs uppercase tracking-wider text-ball-yellow">
        {t('match.suggestions', { n: suggestions.length })}
      </div>
      {suggestions.map((s) => (
        <div key={s.id} className="flex items-center gap-2">
          <span className="flex-1 text-sm">{describe(s.event, t)}</span>
          <button type="button" onClick={() => onResolve(s, true)} className="btn bg-ball-green px-3 py-1 text-sm">
            {t('match.accept')}
          </button>
          <button type="button" onClick={() => onResolve(s, false)} className="btn-ghost px-3 py-1 text-sm">
            {t('match.reject')}
          </button>
        </div>
      ))}
    </div>
  );
}
